/** Tresor storage tiers — 200 GB per unit, max 5 units = 1 TB */
export const TRESOR_UNIT_GB = 200;
export const TRESOR_MAX_GB = 1000;

export const TRESOR_TIERS = [
  { id: 'starter', name: 'Starter', size: '200 GB', units: 1, gb: 200, desc: 'Für private Dokumente und kleine Archive.' },
  { id: 'pro', name: 'Pro', size: '600 GB', units: 3, gb: 600, desc: 'Für Selbstständige und große Foto-Archive.', popular: true },
  { id: 'max', name: 'Max', size: '1 TB', units: 5, gb: 1000, desc: '1 TB im Tarif. Mehr Speicher auf Anfrage.' }
];

export const TIER_BY_ID = Object.fromEntries(TRESOR_TIERS.map((t) => [t.id, t]));

/** 'trial' gehoert mit in die Reihenfolge: ohne den Eintrag fiel die Testphase auf den
 *  Standardwert 1 zurueck und getUpgradeTargets() liess ausgerechnet den 200-GB-Tarif weg,
 *  den ein Testkunde buchen soll. */
export const PLAN_ORDER = { trial: 0, starter: 1, pro: 2, max: 3 };

/** Listenpreis je 200-GB-Einheit, identisch zu den Stripe-Preisen (Menge x Einheitspreis). */
export const UNIT_PRICE_ANNUAL_EUR = 30;
export const UNIT_PRICE_MONTHLY_EUR = 3;

export function tierPriceMonthly(units, cycle) {
  return units * (cycle === 'annual' ? 2.5 : 3.0);
}

/** Betrag, der tatsaechlich abgebucht wird: einmal im Jahr, oder monatlich. */
export function tierChargeAmount(units, cycle) {
  return units * (cycle === 'annual' ? UNIT_PRICE_ANNUAL_EUR : UNIT_PRICE_MONTHLY_EUR);
}

export function cycleLabel(cycle) {
  return cycle === 'annual' ? 'jährlich' : 'monatlich';
}

export function chargeUnitLabel(cycle) {
  return cycle === 'annual' ? 'pro Jahr' : 'pro Monat';
}

export function getUpgradeTargets(currentPlan) {
  // ?? statt ||: PLAN_ORDER.trial ist 0 und waere sonst als "fehlt" durchgefallen.
  const currentOrder = PLAN_ORDER[currentPlan] ?? 1;
  return TRESOR_TIERS.filter((t) => PLAN_ORDER[t.id] > currentOrder);
}

export function comparePlans(targetPlan, currentPlan) {
  const targetOrder = PLAN_ORDER[targetPlan] ?? 0;
  const currentOrder = PLAN_ORDER[currentPlan] ?? 0;
  if (targetOrder === currentOrder) return 'same';
  if (targetOrder > currentOrder) return 'upgrade';
  return 'downgrade';
}
